import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import VerifyEmailBanner from './VerifyEmailBanner';
import api from '../../services/api';

const NAV = [
  {
    items: [
      { to: '/dashboard',     label: 'Dashboard',     icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
      { to: '/roles',         label: 'Browse roles',  icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
      { to: '/jd-prep',       label: 'JD Prep',       icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { to: '/ats',           label: 'ATS CV Score',  icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { to: '/my-interviews', label: 'My Interviews', icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
      { to: '/mock-interview',label: 'Mock Interview',icon: 'M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z' },
      { to: '/performance',   label: 'Performance',   icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
      { to: '/courses',       label: 'Study Guides',  icon: 'M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0112 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z' },
      { to: '/blog',          label: 'Blog',          icon: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z' },
      { to: '/certificates',  label: 'Certificates',  icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z' },
      { to: '/wallet',        label: 'Wallet',        icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z' },
      { to: '/refer',         label: 'Refer & Earn',  icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
    ],
  },
  {
    label: 'AI Tools',
    items: [
      { to: '/star-coach',       label: 'STAR Coach',        icon: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',                                                                                       tier: 'full_access' },
      { to: '/cover-letter',     label: 'Cover Letter',      icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',                                                              tier: 'full_access' },
      { to: '/company-prep',     label: 'Company Prep',      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-2 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',                                      tier: 'full_access' },
      { to: '/debrief',          label: 'Interview Debrief', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',                 tier: 'full_access' },
      { to: '/linkedin-opt',     label: 'LinkedIn Optimiser',icon: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 6a2 2 0 100-4 2 2 0 000 4z',                                                             tier: 'job_seeker' },
      { to: '/salary-neg',       label: 'Salary Negotiation',icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',    tier: 'job_seeker' },
      { to: '/readiness-report', label: 'Readiness Report',  icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z', tier: 'job_seeker' },
    ],
  },
];

const BOTTOM_NAV = [
  { to: '/settings', label: 'Settings', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },
];

function NavIcon({ d, size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {d.split(' M').map((segment, i) => (
        <path key={i} d={i === 0 ? segment : 'M' + segment} />
      ))}
    </svg>
  );
}

function LockIcon() {
  return (
    <svg width={10} height={10} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, opacity: 0.5 }}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
    </svg>
  );
}

function NotificationBell({ open: sidebarOpen }) {
  const [count,        setCount]        = useState(0);
  const [dropOpen,     setDropOpen]     = useState(false);
  const [notifs,       setNotifs]       = useState([]);
  const [loadingNotifs, setLoadingNotifs] = useState(false);
  const [dropPos,      setDropPos]      = useState({ top: 0, left: 0 });
  const dropRef  = useRef(null);
  const btnRef   = useRef(null);
  const navigate = useNavigate();

  const fetchCount = () => {
    api.get('/notifications/count').then(r => setCount(r.data.unread_count || 0)).catch(() => {});
  };

  useEffect(() => {
    fetchCount();
    const iv = setInterval(fetchCount, 60_000);
    return () => clearInterval(iv);
  }, []); // eslint-disable-line

  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const openDrop = () => {
    if (!dropOpen && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setDropPos({ top: rect.bottom + 6, left: rect.left });
    }
    setDropOpen(o => !o);
    if (!dropOpen) {
      setLoadingNotifs(true);
      api.get('/notifications').then(r => { setNotifs(r.data.notifications || []); }).catch(() => {}).finally(() => setLoadingNotifs(false));
    }
  };

  const markRead = (id, link) => {
    api.patch(`/notifications/${id}/read`).catch(() => {});
    setNotifs(ns => ns.map(n => n.id === id ? { ...n, is_read: true } : n));
    setCount(c => Math.max(0, c - 1));
    if (link) { setDropOpen(false); navigate(link); }
  };

  const markAll = () => {
    api.patch('/notifications/read-all').catch(() => {});
    setNotifs(ns => ns.map(n => ({ ...n, is_read: true })));
    setCount(0);
  };

  return (
    <div ref={dropRef} style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <button ref={btnRef} onClick={openDrop} title="Notifications"
        style={{ position: 'relative', background: 'none', border: 'none', cursor: 'pointer', padding: 6, borderRadius: 6, display: 'flex', color: 'rgba(255,255,255,0.6)', transition: 'color 0.12s' }}
        onMouseEnter={e => e.currentTarget.style.color = '#fff'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'}>
        <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"/>
        </svg>
        {count > 0 && (
          <span style={{ position: 'absolute', top: 2, right: 2, width: 16, height: 16, borderRadius: '50%', background: '#C1272D', color: '#fff', fontSize: 9, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>
            {count > 9 ? '9+' : count}
          </span>
        )}
      </button>

      {dropOpen && (
        <div style={{ position: 'fixed', top: dropPos.top, left: dropPos.left, width: 300, background: '#fff', border: '1px solid #E2E8F0', borderRadius: 12, boxShadow: '0 8px 30px rgba(0,0,0,0.15)', zIndex: 9999, overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#0F172A' }}>Notifications</span>
            {count > 0 && (
              <button onClick={markAll} style={{ fontSize: 11, color: '#1B3A5C', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, padding: 0, fontFamily: 'inherit' }}>Mark all read</button>
            )}
          </div>
          <div style={{ maxHeight: 340, overflowY: 'auto' }}>
            {loadingNotifs ? (
              <div style={{ padding: '20px 16px', textAlign: 'center', fontSize: 13, color: '#94A3B8' }}>Loading…</div>
            ) : notifs.length === 0 ? (
              <div style={{ padding: '24px 16px', textAlign: 'center', fontSize: 13, color: '#94A3B8' }}>No notifications yet</div>
            ) : notifs.map(n => (
              <div key={n.id} onClick={() => markRead(n.id, n.link)}
                style={{ padding: '12px 16px', borderBottom: '1px solid #F8FAFC', background: n.is_read ? '#fff' : '#F0F7FF', cursor: n.link ? 'pointer' : 'default', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: n.is_read ? 'transparent' : '#1B3A5C', flexShrink: 0, marginTop: 5 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ margin: '0 0 2px', fontSize: 13, fontWeight: n.is_read ? 400 : 600, color: '#0F172A', lineHeight: 1.4 }}>{n.title}</p>
                  {n.body && <p style={{ margin: 0, fontSize: 12, color: '#64748B', lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{n.body}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function SidebarNav({ open, onNavClick, isFullAccess, isJobSeeker }) {
  return (
    <nav style={{ flex: 1, overflowY: 'auto', padding: '8px 0', scrollbarWidth: 'none', minHeight: 0 }}>
      {NAV.map(({ label, items }, gi) => (
        <div key={gi}>
          {label && open && (
            <p style={{ margin: '10px 16px 4px', fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{label}</p>
          )}
          {items.map(({ to, icon, label: itemLabel, newTab, tier }) => {
            const locked = tier === 'full_access' ? !isFullAccess : tier === 'job_seeker' ? !isJobSeeker : false;
            if (newTab) {
              return (
                <a key={to} href={to} target="_blank" rel="noopener noreferrer"
                  aria-label={itemLabel} title={!open ? itemLabel : undefined}
                  onClick={onNavClick}
                  style={{ display: 'flex', alignItems: 'center', gap: 11, padding: open ? '9px 14px' : '9px 0', justifyContent: open ? 'flex-start' : 'center', margin: '1px 8px', borderRadius: 8, textDecoration: 'none', fontSize: 14, fontWeight: 400, color: 'rgba(255,255,255,0.78)', background: 'transparent', borderLeft: '3px solid transparent', transition: 'background 0.12s, color 0.12s', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                  <NavIcon d={icon} />
                  {open && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>{itemLabel}</span>}
                </a>
              );
            }
            return (
              <NavLink key={to} to={to} end={to === '/dashboard'}
                aria-label={itemLabel} title={!open ? itemLabel : undefined}
                onClick={onNavClick}
                style={({ isActive }) => ({
                  display: 'flex', alignItems: 'center', gap: 11,
                  padding: open ? '9px 14px' : '9px 0',
                  justifyContent: open ? 'flex-start' : 'center',
                  margin: '1px 8px', borderRadius: 8,
                  textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#fff' : locked ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.78)',
                  background: isActive ? 'rgba(255,255,255,0.11)' : 'transparent',
                  borderLeft: isActive ? '3px solid #C1272D' : '3px solid transparent',
                  transition: 'background 0.12s, color 0.12s',
                  overflow: 'hidden', whiteSpace: 'nowrap',
                })}>
                <NavIcon d={icon} />
                {open && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>{itemLabel}</span>}
                {open && locked && <LockIcon />}
              </NavLink>
            );
          })}
        </div>
      ))}
    </nav>
  );
}

function SidebarBottom({ open, user, onLogout, onNavClick, isJobSeeker }) {
  const [confirmLogout, setConfirmLogout] = useState(false);
  return (
    <div style={{ flexShrink: 0, borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      {!isJobSeeker && (
        <div style={{ padding: open ? '10px 12px 4px' : '10px 8px 4px' }}>
          <NavLink to="/pricing" onClick={onNavClick} title={!open ? 'Upgrade plan' : undefined}
            style={{ display: 'flex', alignItems: 'center', gap: 8, padding: open ? '9px 12px' : '9px 0', justifyContent: open ? 'flex-start' : 'center', borderRadius: 9, background: 'rgba(193,39,45,0.15)', border: '1px solid rgba(193,39,45,0.3)', textDecoration: 'none', transition: 'background 0.15s' }}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(193,39,45,0.28)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(193,39,45,0.15)'; }}>
            <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="#C1272D" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
              <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
            {open && <span style={{ fontSize: 13, fontWeight: 700, color: '#C1272D', whiteSpace: 'nowrap' }}>Upgrade plan</span>}
          </NavLink>
        </div>
      )}
      {BOTTOM_NAV.map(({ to, icon, label }) => (
        <NavLink key={to} to={to} onClick={onNavClick}
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 11,
            padding: open ? '9px 14px' : '9px 0',
            justifyContent: open ? 'flex-start' : 'center',
            margin: '4px 8px', borderRadius: 8,
            textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
            color: isActive ? '#fff' : 'rgba(255,255,255,0.78)',
            background: isActive ? 'rgba(255,255,255,0.11)' : 'transparent',
            borderLeft: isActive ? '3px solid #C1272D' : '3px solid transparent',
            transition: 'background 0.12s',
          })}>
          <NavIcon d={icon} />
          {open && <span>{label}</span>}
        </NavLink>
      ))}

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: open ? '10px 14px 14px' : '10px 0 14px', justifyContent: open ? 'flex-start' : 'center' }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#C1272D', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, flexShrink: 0, cursor: 'default', letterSpacing: '0.5px' }}>
          {(user?.full_name || user?.email || '?').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?'}
        </div>
        {open && (
          <>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, color: '#fff', fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.full_name}</p>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.58)', fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email}</p>
            </div>
            {confirmLogout ? (
              <div style={{ display: 'flex', gap: 5, flexShrink: 0 }}>
                <button onClick={onLogout} title="Confirm sign out" style={{ background: '#C1272D', border: 'none', color: '#fff', cursor: 'pointer', padding: '3px 8px', borderRadius: 5, fontSize: 11, fontWeight: 700, fontFamily: 'inherit' }}>Yes</button>
                <button onClick={() => setConfirmLogout(false)} title="Cancel" style={{ background: 'rgba(255,255,255,0.12)', border: 'none', color: 'rgba(255,255,255,0.8)', cursor: 'pointer', padding: '3px 8px', borderRadius: 5, fontSize: 11, fontWeight: 600, fontFamily: 'inherit' }}>No</button>
              </div>
            ) : (
              <button onClick={() => setConfirmLogout(true)} title="Sign out" aria-label="Sign out"
                style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.45)', cursor: 'pointer', padding: 4, borderRadius: 6, display: 'flex', flexShrink: 0, transition: 'color 0.12s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}>
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
                </svg>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default function UserLayout({ children }) {
  const { user, logout, subscriptions } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const isFullAccess = subscriptions?.some(s => ['full_access', 'job_seeker'].includes(s.plan_type) || ['full_access', 'job_seeker'].includes(s.tier)) ?? false;
  const isJobSeeker  = subscriptions?.some(s => s.plan_type === 'job_seeker' || s.tier === 'job_seeker') ?? false;

  const sidebarStyle = {
    width: open ? 240 : 60,
    background: '#0F172A',
    display: 'flex', flexDirection: 'column',
    flexShrink: 0, transition: 'width 0.18s ease',
    overflow: 'hidden', position: 'sticky', top: 0, height: '100vh',
  };

  const logoRow = (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: open ? 'space-between' : 'center', height: 56, padding: open ? '0 10px 0 18px' : '0', flexShrink: 0, borderBottom: '1px solid rgba(255,255,255,0.07)', gap: 6 }}>
      {open && (
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16, letterSpacing: '-0.3px', whiteSpace: 'nowrap', flex: 1 }}>
          Centric<span style={{ color: '#C1272D' }}>Q</span>
        </span>
      )}
      <NotificationBell open={open} />
      <button onClick={() => setOpen(o => !o)} aria-label="Toggle sidebar"
        style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.52)', cursor: 'pointer', padding: 5, borderRadius: 6, display: 'flex', transition: 'color 0.12s', flexShrink: 0 }}
        onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}>
        <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          {open
            ? <><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M15 9l-3 3 3 3"/></>
            : <><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M9 9l3 3-3 3"/></>
          }
        </svg>
      </button>
    </div>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        .ul-sidebar   { display: flex !important; }
        .ul-mob-bar   { display: none  !important; }
        .ul-mob-ov    { display: none  !important; }
        @media (max-width: 768px) {
          .ul-sidebar { display: none  !important; }
          .ul-mob-bar { display: flex  !important; }
          .ul-mob-ov  { display: flex  !important; }
          .ul-main    { padding-top: 52px !important; }
        }
        nav a:hover { background: rgba(255,255,255,0.09) !important; color: #fff !important; }
        .skip-link { position:absolute; left:-9999px; top:auto; width:1px; height:1px; overflow:hidden; }
        .skip-link:focus { position:fixed; left:16px; top:16px; width:auto; height:auto; padding:10px 18px;
          background:#1B3A5C; color:#fff; font-weight:700; font-size:14px; border-radius:8px; z-index:9999;
          text-decoration:none; outline:2px solid #C1272D; }
        @keyframes ul-slide-in { from { transform: translateX(-100%); } to { transform: translateX(0); } }
        .ul-mob-ov aside { animation: ul-slide-in 0.22s ease; }
        @media (max-width: 768px) {
          nav a, nav button { min-height: 44px !important; }
        }
        @media print {
          .ul-sidebar { display: none !important; }
          .ul-mob-bar { display: none !important; }
          .ul-mob-ov  { display: none !important; }
          .ul-main    { padding-top: 0 !important; }
        }
      `}</style>
      <a href="#main-content" className="skip-link">Skip to main content</a>

      {/* Desktop sidebar */}
      <aside className="ul-sidebar" style={sidebarStyle}>
        {logoRow}
        <SidebarNav open={open} isFullAccess={isFullAccess} isJobSeeker={isJobSeeker} />
        <SidebarBottom open={open} user={user} onLogout={handleLogout} isJobSeeker={isJobSeeker} />
      </aside>

      {/* Mobile top bar */}
      <div className="ul-mob-bar" style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 52, background: '#0F172A', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', zIndex: 50, borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>Centric<span style={{ color: '#C1272D' }}>Q</span></span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <NotificationBell open={false} />
          <button onClick={() => setMobileOpen(o => !o)} aria-label="Toggle menu"
            style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: 4, display: 'flex' }}>
            <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
              {mobileOpen
                ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                : <><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>
              }
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="ul-mob-ov" style={{ position: 'fixed', inset: 0, zIndex: 40, background: 'rgba(0,0,0,0.5)' }}
          onClick={() => setMobileOpen(false)}>
          <aside style={{ width: 240, background: '#0F172A', height: '100%', display: 'flex', flexDirection: 'column' }}
            onClick={e => e.stopPropagation()}>
            {logoRow}
            <SidebarNav open={true} onNavClick={() => setMobileOpen(false)} isFullAccess={isFullAccess} isJobSeeker={isJobSeeker} />
            <SidebarBottom open={true} user={user} onLogout={handleLogout} onNavClick={() => setMobileOpen(false)} isJobSeeker={isJobSeeker} />
          </aside>
        </div>
      )}

      {/* Main content */}
      <main id="main-content" className="ul-main" style={{ flex: 1, background: 'var(--bg, #F8FAFC)', overflowY: 'auto', overflowX: 'hidden', minWidth: 0 }}>
        <VerifyEmailBanner />
        {children}
      </main>
    </div>
  );
}
